import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import strings from 'owa-strings/owa-common-strings';
import { FeedbackForm } from 'owa-feedback';
import { observer } from 'mobx-react';
var styles = require('./FeedbackPane.scss');
var FeedbackPane = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackPane, _super);
    function FeedbackPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSend = function () {
            _this.props.onDismiss();
        };
        return _this;
    }
    FeedbackPane.prototype.renderFeedbackForm = function () {
        return (React.createElement("div", { className: styles.menuFeedback },
            React.createElement(FeedbackForm, { onSendFeedback: this.onSend })));
    };
    FeedbackPane.prototype.render = function () {
        return (React.createElement(HeaderFlexPane, { title: function () { return strings.feedbackCharm_ariaLabel; }, content: this.renderFeedbackForm(), onDismiss: this.props.onDismiss }));
    };
    FeedbackPane = tslib_1.__decorate([
        observer
    ], FeedbackPane);
    return FeedbackPane;
}(React.Component));
export default FeedbackPane;
//# sourceMappingURL=FeedbackPane.js.map